export const EmptyObject = Object.freeze({});
export const EmptyArray = Object.freeze([]);
export const EmptyCallback = Object.freeze(() => {});
